import React, {useEffect, useState, Fragment} from 'react'
import { localizeUrl, secondsToMinutes, getFeaturedImageUrl } from '../../../services/service-utils'
import styles from './AudioGuidesListItem.css'
import { Link } from 'react-router-dom'
import { LIB } from '../../../constants/consts-types'
import { getPageData } from '../../../services/service-wp'
import { _try } from '../../../services/service-utils'

const audioListUrl = (language, audioguide = {}) => localizeUrl(language, `/${audioguide.post_type}/${audioguide.post_name}/`)

const fetchAudioGuideData = async (language, audioguide = {}) => {
  const path = localizeUrl(language, `/${audioguide.post_type}/${audioguide.post_name}/`)
  const jsonResult = await getPageData(path, '?_embed')
  return jsonResult
}

const fetchEpisodes = async (language, audioGuideList = []) => {
  
  const filterPublished = audioList => _try(() => audioList.audio_guide_episode_item.post_status) === 'publish'
  const episodes = await Promise.all(audioGuideList
    .filter(filterPublished)
    .map(async audioList => {
      const path = localizeUrl(language, `/${audioList.audio_guide_episode_item.post_type}/${audioList.audio_guide_episode_item.post_name}/`)
      const episodeResponseJSON = await getPageData(path, '?_embed')
      return episodeResponseJSON
    })
  )
  return episodes
}

const fetchArtworks = async artworksIds => {

  const artworksIdsAsString = artworksIds.join().trim()

  // Fetch a list of artworks from API to determine which ones are on display
  const fetchArtworksUrl = `https://api.smk.dk/api/v1/art/?object_number=${artworksIdsAsString}&lang=da`
  try {
    const result = await fetch(fetchArtworksUrl)
    const jsonResult = await result.json()
    return (jsonResult && jsonResult.items) || []
  } catch (error) {
    // NOTE: Bit curious use case. If the API fails, we should act as if items are on display.
    // Otherwise the episodes list would be empty
    const mockArtworkList = artworksIds.map(artworkId => ({ object_number: artworkId, on_display: true }))
    return mockArtworkList
  }
}

const AudioGuidesListItem = ({ audioguide, language, onLoaded }) => {

  const [episodesToShow, setEpisodesToShow] = useState([])
  const [sourceUrl, setSourceUrl] = useState('')
  const [colors, setColors] = useState({})
    
  // Calculate total episodes duration
  const tracksDuration = episodesToShow
    .reduce((acc, item) => acc + Number(_try(() => item.acf.episode_duration, 0)), 0)
    || 0
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const audioGuideData = await fetchAudioGuideData(language, audioguide)

        // Colors
        setColors(_try(() => audioGuideData.colors, {}))

        // Image URL
        setSourceUrl(_try(() => getFeaturedImageUrl(audioGuideData), ''))

        const episodes = await fetchEpisodes(language, audioGuideData.audio_guide_list || [])
        const artworksIds = episodes && episodes.map(track => _try(() => track.acf.artwork_id)).filter(track => track !== '')
        const artworks = await fetchArtworks(artworksIds)
        const onDisplayArtworks = artworks.filter(artwork => artwork.on_display)
        const onDisplayArtworksIds = onDisplayArtworks.map(artwork => artwork.object_number)

        // Determine which episodes to show (episodes realeted to artworks with (on_display = true) or artwordID is blank)
        const _episodesToShow = (episodes && episodes.length)
          ? episodes.filter(episode => (
              episode && (onDisplayArtworksIds.includes(_try(() => episode.acf.artwork_id)) || !_try(() => episode.acf.artwork_id)))
            )
          : []

        setEpisodesToShow(_episodesToShow)
      } catch(err) {
        console.log("Fetch error: ", err)
      } finally {
        onLoaded()
      }
    }
    
    fetchData()
  }, [])

  return (
    episodesToShow.length > 0 && (
      <Link
        to={{ pathname: audioListUrl(language, audioguide) }} 
        className={`${styles.audioGuideListItem}`}
        style={{ textDecoration: "none", backgroundColor: colors.background, color: colors.foreground }}
      >
        <div className="row">
          <div className={`col-xs-12 ${styles.coverImage}`}>
            <img alt="" src={sourceUrl} /> 
          </div>
        </div>
        <div className={`container-fluid ${styles.audioGuideListItemInfo}`}>
          {/* audioGuideListItem header/info container */}
          <div className={`row ${styles.header}`}>
            <div className="col-xs-12">
              {audioguide.post_title}
            </div>
          </div>
          <div className="row">
            <div className={`col-xs-12 ${styles.subHeader}`}>
              {audioguide.post_excerpt}
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {`${episodesToShow.length} ${LIB.audio_guide_episodes} `}
              {tracksDuration !== 0 && (
                <Fragment>
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  {`${secondsToMinutes(tracksDuration)} min ${LIB.audio_guide_total.toLowerCase()}`}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Link>
    )
  )
}

export default AudioGuidesListItem



// WEBPACK FOOTER //
// ./src/components/AudioGuideComponents/AudioGuidesListItem/AudioGuidesListItem.js